module.exports = __webpack_public_path__ + "static/media/Chile.34fd9fb9.png";